module.exports = __webpack_public_path__ + "static/media/how-it-works-step-1-alt.87785f11.jpg";